import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';
import { brandDetector } from '@/brands';

const accionesAlumno = {
	state: {
		candidaturas: {
			empleo: '',
			practicas: ''
		},
		ofertas: {
			empleo: [],
			practicas: []
		},
		ofertasParams: {
			empleo: '',
			practicas: ''
		},
		filtros: {
			empleo: {
				list: ['contrato', 'salario', 'titulaciones', 'areasTitulaciones', 'tipoModalidadAsistencia'],
				data: ''
			},
			practicas: {
				list: brandDetector().listBusquedaPractica,
				data: ''
			}
		},
		directorioAlumnos: null,
		alumnoDirectorio:null,
		practicasEnValidacion: '',
		faltanDatosPersonalesObligatorios: null,
		ofertasqueencajan: false,
		ibanRequired: false,
		ofertasloaded: false
	},
	getters: {
		getCandidaturas: state => state.candidaturas,
		getCandidaturasEmpleo: state => state.candidaturas.empleo,
		getCandidaturasPracticas: state => state.candidaturas.practicas,
		getOfertas: state => state.ofertas,
		getOfertasEmpleo: state => state.ofertas.empleo,
		getOfertasPracticas: state => state.ofertas.practicas,
		getPracticasEnValidacion: state => state.practicasEnValidacion,
		getParamsOfertas: state => state.ofertasParams,
		getFiltros: state => state.filtros,
		getTypes: state => ['practicas', 'empleo'],
		getOfertasQueEncajan: state => state.ofertasqueencajan,
		getibanRequired: state => state.ibanRequired,
		getofertasloaded: state => state.ofertasloaded,
		getDirectorioAlumnos: state => state.directorioAlumnos,
		getAlumnoDirectorio:state => state.alumnoDirectorio,
		getStatusOferta: state => {

			return (oferta, tipo) => {

				if (state.candidaturas[tipo].length > 0) {

					let result = state.candidaturas[tipo].filter(c => c.urlAcceso == oferta)[0];

					if (!!result) {
						return result.estado;
					}


				}

			}
		},
		getfaltanDatosPersonalesObligatorios: state => {
			return state.faltanDatosPersonalesObligatorios;
		}
	},
	actions: {

		requestCandidaturas: function ({ commit, getters, dispatch }) {

			let types = getters.getTypes;

			types.forEach(type => {

				axios.get(`/api/Alumno/dameCandidaturas${type}Usuario`).then(response => {

					if (response.data.status == 0) {
						commit('setCandidaturas', [type, response.data.datos])
					} else {
						commit('setCompleteError', response);
					}
				}).catch(error => {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});

			});

		},
		requestParamsOfertas: function ({ commit, dispatch, getters }) {

			let types = ['Empleo', 'Practicas'];

			types.forEach(type => {

				axios.get(`/api/Alumno/dameNumOfertas${type}Usuario`).then(r => {

					let result = r.data;
					if (result.status == 0) {
						commit('setParamsOfertas', [type, result.datos]);
						dispatch('requestOfertas', type.toLowerCase());
						commit('setofertasloaded')
					} else {
					}

				}).catch(error => {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});

			});
		},
		requestOfertas: function ({ commit, getters, dispatch }, type) {

			axios.get(`/api/Alumno/dameOfertasUsuario/${type}`).then(r => {

				let result = r.data;

				if (result.status == 0 && result.datos.numTotal > 0) {

					commit('addOfertas', [type, result.datos]);

					if (getters.getOfertas[type].length == getters.getParamsOfertas[type].numTotal) {
						dispatch('calcularFiltros', type);
						commit("ordenarFechas", type);
					}

				}

			}).catch(error => {
				commit('setError', 500);
				dispatch('sendErrorServer', error.response);
			});

		},
		requestOfertasQueEncajan({ commit }) {
			axios.get(`/api/Alumno/ofertasEncajanConUsuario`).then(response => {
				(response.data.status == 0) ? commit('setOfertasQueEncajan', response.data.datos.ofertas) : commit('setCompleteError', response);
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		requestOferta: function ({ commit, dispatch }, idOferta) {

			return new Promise((resolve, reject) => {
				axios.get(`/api/Alumno/dameOferta/${idOferta}`).then(response => {
					(response.data.status == 0) ? resolve(response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		inscribirseOferta: function ({ commit, dispatch, getters }, data) {
			return new Promise((resolve, reject) => {


				axios.post(`/api/Alumno/inscribirse/`, data).then(response => {

					if (response.data.status == 0) {
						dispatch('requestCandidaturas');
						if (!!response.data.mensaje) {
							response.data.status = 515;
							commit('setErrorMensaje', response.data);
						} else {
							if (data.inscripcionExterna == false) {
								commit('setError', 502);
							}
						}
						resolve(true);
					} else if (response.data.status == 11) {
						if (!!response.data.datos.documentacionNecesaria) {
							reject(response.data);
						} else {
							resolve(false);
							commit('setCompleteError', response);
						}
					} else if (response.data.status == 80) {

						let data = {
							response: response.data.mensaje,
							lang: getters.getLanguage,
							getters: getters
						};

						commit('setErrorRequisitos', data);
						resolve(false);
					} else {
						resolve(false);
						commit('setCompleteError', response);
					}

				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		desInscribirseOferta: function ({ commit, dispatch }, urlOferta) {
			return new Promise((resolve, reject) => {

				let data = { "urlOferta": urlOferta };

				axios.post(`/api/Alumno/desinscribirse/`, data).then(response => {

					if (response.data.status == 0) {
						commit('setError', 501);
						resolve(true);
					} else {
						resolve(false);
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		calcularFiltros: function ({ commit, getters, dispatch }, type) {

			let ofertas = (type == "empleo") ? getters.getOfertasEmpleo : getters.getOfertasPracticas;

			if (!!ofertas) {

				let filtersBy = getters.getFiltros[type].list;

				let filters = new Object();

				filtersBy.forEach(el => filters[el] = new Array());

				ofertas.forEach(oferta => {

					filtersBy.forEach(filtro => {

						if (!!oferta[filtro] && oferta[filtro].length != 0) {

							// UNICO VALOR
							if (typeof oferta[filtro] == 'string' | typeof oferta[filtro] == 'number') {
								if (!!oferta[filtro] & !filters[filtro].some(el => el == oferta[filtro])) {
									filters[filtro].push(oferta[filtro])
								}
							} else {
								//ARRAY DE VALORES
								let topush = oferta[filtro].filter(f => {
									return (!filters[filtro].some(e => e == f));
								});
								filters[filtro] = filters[filtro].concat(topush);

							}
						}
					});

				});

				for (let i in filters) {

					if (i != 'salario') {
						filters[i].sort();
					} else {
						filters[i].sort((a, b) => {
							let aval = Number(a.split("€")[0].trim());
							let bval = Number(b.split("€")[0].trim());

							if (!!!aval) {
								aval = Number(a.split(".")[0].substr(-2, 2))
							}

							if (!!!bval) {
								bval = Number(b.split(".")[0].substr(-2, 2))
							}

							return (aval > bval) ? 1 : -1;
						});

					}


				}

				commit('setFiltros', [type, filters]);

			}

		},
		editarUsuario: function ({ commit, dispatch }, usuario) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Alumno/editaUsuario').then(response => {
					if (response.data.status == 0) {
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestPracticasEnValidacion: function ({ commit, dispatch }) {

			return new Promise((resolve, reject) => {
				axios.get(`api/Alumno/damePracticasAlumno`).then(response => {
					(response.data.status == 0) ? commit('setPracticasValidacion', response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		addFicheroPractica: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				data.forEach((d, key) => {

					axios.post(`/api/Alumno/addFicheroPractica`, d).then(response => {

						if (response.data.status == 0) {

							if (key + 1 == data.length) {
								commit('setError', 513)
								dispatch('requestPracticasEnValidacion');
								resolve(true);
							}

						} else {
							commit('setCompleteError', response);
						}
					}).catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});

				});


			});
		},
		addFicheroRenunciaSet: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				data.forEach((d, key) => {

					axios.post(`/api/Alumno/addFicheroRenunciaSet`, d).then(response => {

						if (response.data.status == 0) {

							if (key + 1 == data.length) {
								commit('setError', 513)
								dispatch('requestPracticasEnValidacion');
								resolve(true);
							}

						} else {
							commit('setCompleteError', response);
						}
					}).catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});

				});


			});
		},
		requestEraseAccount: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {

				axios.post('/api/alumno/solicitarBajaServicio').then(response => {
					if (response.data.status == 0) {
						commit('setError', 517);
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		sendPasswordAlumno: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/alumno/restablecerPassword', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 508);
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		aceptarPreinscripcion: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/alumno/aceptarPreinscripcion', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 519);
						dispatch('requestCandidaturas').then(r => {
							resolve(true);
						})
					} else {
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});

		},
		rechazarPreinscripcion: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/alumno/rechazarPreinscripcion', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 519);
						dispatch('requestCandidaturas').then(r => {
							resolve(true);
						})
					} else {
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});

		},
		editarPassword: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/alumno/editarPassword', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 521);
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});

		},

		registrarAlumno: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/alumno/registrarUsuario', data).then(response => {
					if (response.data.status == 0) {

						let data = {
							response: response,
							type: 'Alumno'
						}

						dispatch('loggedThings', data)

						commit('setError', 522);
						resolve(true);

					} else {
						resolve(false);
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});

		},
		recuerdoPassAlumno: function ({ commit, dispatch }, nick) {

			let data = { 'usuario': nick };

			return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/solicitarReseteoPassword', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 505);
						resolve(true);
					} else {
						resolve(false);
						commit('setError', 524);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		checkDatosPersonalesObligatorios: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {

				axios.get('/api/Alumno/faltanDatosPersonalesObligatorios').then(response => {
					if (response.data.status == 0) {
						commit('setFaltanDatosPersonalesObligatorios', response.data.datos)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});

		},
		checkIbanInPracticasConServicio: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {

				axios.get('/api/Alumno/faltanDatosPersonalesObligatorios').then(response => {
					if (response.data.status == 0) {
						commit('setibanRequired', response.data.datos)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});

		},
		setStatusOfertasQueEncajan({ commit, dispatch }, status) {
			commit('setStatusOfertasQueEncajan', status);
			if (!!status) {
				dispatch('requestOfertasQueEncajan');
			} else {
				dispatch('requestParamsOfertas');
			}
		},
		checkAvisoCreditos({ commit }, url) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Alumno/sacaAvisoDeMinimoDeCreditosParaInscribirse/${url}`).then(response => {
					resolve(response.data.datos)
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		checkSolicitudesAlumno({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Alumno/numeroSolicitudPracticasEducacionDisponibles').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		addDocumentoPractica({ commit }, data) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/addDocumentoPractica', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
					} else {
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		sendAnexoCF({ commit }, data) {

			if (!data.fichero.ficheroB64) {
				delete data.fichero;
			}
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editDocumentoSeguimientoCF', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
					} else {
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		enviarSolicitudOrientacion({ commit }, data) {
			return new Promise((resolve, reject) => {
				console.log(data)
				axios.post('/api/Alumno/enviarSolicitudOrientacion', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 539);
						resolve(true);
					} else {
						commit('setError', response.data.status);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		dameRecursoUsuario: function ({ commit, dispatch }, idRecurso) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Alumno/dameRecursoUsuario/${idRecurso}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		dameTestimonialUsuario: function ({ commit, dispatch }, idTestimonial) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Alumno/dameTestimonialUsuario/${idTestimonial}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		dameTallerUsuario: function ({ commit, dispatch }, idTaller) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Alumno/dameTallerUsuario/${idTaller}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		
		requestDirectorioAlumnos: function ({ commit, dispatch, state }) {
			if (state.directorioAlumnos) {
                return true
            }
			return new Promise((resolve, reject) => {
				axios.get(`/api/Alumno/dameDirectorioAntiguosAlumnos`).then(response => {
					if (response.data.status == 0) {
						response.data.datos.sort((a, b) => a.nombreCompletoAlumno.localeCompare(b.nombreCompletoAlumno, 'es', { sensitivity: 'base' }));
						state.directorioAlumnos = response.data.datos
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestAlumnoDirectorio: function ({ commit, dispatch, state }, id) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Alumno/dameDirectorioAntiguoAlumno/${id}`).then(response => {
					if (response.data.status == 0) {
						state.alumnoDirectorio = response.data.datos
						resolve(response.data.datos);
						console.log(state.alumnoDirectorio)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
	},
	mutations: {
		setCandidaturas: function (state, data) {
			state.candidaturas[data[0].toLowerCase()] = data[1];
		},
		addOfertas: function (state, data) {
			state.ofertas[data[0]] = state.ofertas[data[0]].concat(data[1].ofertas);
		},
		ordenarFechas(state, type) {
			let ofertas = new Object();

			state.ofertas[type] = state.ofertas[type].sort((o1, o2) => {
				let f1 = (o1.fechaDestacada) ? o1.fechaDestacada.split("/") : o1.fecha.split("/");
				let d1 = new Date(f1[2], f1[1], f1[0]).getTime();

				let f2 = (o2.fechaDestacada) ? o2.fechaDestacada.split("/") : o2.fecha.split("/");
				let d2 = new Date(f2[2], f2[1], f2[0]).getTime();

				return (d1 < d2) ? 1 : -1;

			});


		},
		setParamsOfertas: function (state, data) {

			state.ofertas.empleo = [];
			state.ofertas.practicas = [];
			state.ofertasParams[data[0].toLowerCase()] = data[1];
		},
		setFiltros: function (state, data) {
			state.filtros[data[0]].data = data[1];
		},
		setPracticasValidacion: function (state, data) {
			if (data.length > 0) {
				state.practicasEnValidacion = data;
			} else {
				state.practicasEnValidacion = null;
			}
		},
		setFaltanDatosPersonalesObligatorios(state, status) {
			state.faltanDatosPersonalesObligatorios = status;
		},
		setStatusOfertasQueEncajan(state, status) {
			state.ofertasqueencajan = status;
		},
		setOfertasQueEncajan(state, ofertas) {

			if (!!!ofertas) {
				ofertas = [];
			}

			state.ofertas.empleo = [];
			state.ofertas.practicas = [];
			state.ofertasParams.empleo = new Object();
			state.ofertasParams.practicas = new Object();


			ofertas.forEach(o => {
				if (o.textoPerfilOferta == 'Prácticas') {
					state.ofertas.practicas.push(o)
				} else {
					state.ofertas.empleo.push(o)
				}
			})

			state.ofertasParams.empleo.numTotal = state.ofertas.empleo.length;
			state.ofertasParams.practicas.numTotal = state.ofertas.practicas.length;
		},
		setibanRequired(state, value) {
			state.ibanRequired = value;
		},
		setofertasloaded(state) {
			state.ofertasloaded = true;
		}

	}
}

export default accionesAlumno;



// WEBPACK FOOTER //
// ./src/store/accionesAlumno.js